module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "t-carousel"
  }, [_h('ul', {
    staticClass: "carousel",
    style: ({
      'transform': 'translate3d(' + -(index * 20) + '%, 0, 0)'
    })
  }, [_l((carousels), function(carousel) {
    return _h('li', [_h('a', {
      attrs: {
        "href": carousel.url,
        "target": "_blank"
      }
    }, [_h('img', {
      attrs: {
        "src": carousel.pic
      }
    })])])
  })]), " ", _m(0), " ", _h('ul', {
    staticClass: "slider-bar"
  }, [_l((carousels), function(carousel, $index) {
    return _h('li', {
      class: {
        'on': $index === index
      },
      attrs: {
        "bar": "bar"
      },
      on: {
        "click": function($event) {
          go($index)
        },
        "mouseover": end,
        "mouseout": start
      }
    })
  })]), " ", _h('div', {
    staticClass: "s-bottom"
  }, [_h('a', {
    staticClass: "show-info",
    attrs: {
      "href": url,
      "target": "_blank"
    }
  }, [_s(name)])])])
}},staticRenderFns: [function (){with(this) {
  return _h('a', {
    staticClass: "more-topic",
    attrs: {
      "href": "http://www.bilibili.com/topic/integrated-1.html",
      "target": "_blank"
    }
  }, ["\n    更多", _h('i', {
    staticClass: "b-icon b-icon-arrow-r"
  })])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-3!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mcarousel.vue
 ** module id = 34
 ** module chunks = 2
 **/